import { gql } from '@apollo/client';

const SEARCH_QUERY = gql`
query search( 
    $types: [ ES_SearchOptionsTypesEnum! ],
    $query: String,
    $page: Int,
    $limit: Int, 
    $sort: ES_SearchOptionsSortEnum,
    $order: ES_SearchOptionsOrderEnum,
    $personId: UUID, 
    $enrollmentStatuses: [ES_SearchOptionsEnrollmentStatusesEnum!],
    $localeCode: ES_SearchOptionsLocaleCodeEnum,
    $isPublished: Boolean,
    $brandIds: [ UUID! ],
    $categoryId: UUID,
    $_ids: [UUID!],  
    $objectExcludeFormats: [ES_SearchOptionsLearningObjectsFormatEnum!] ) {
        search(searchOptions: { 
            types: $types,
            query: $query,
            page: $page,
            limit: $limit,
            brandIds: $brandIds,
            sort: $sort,
            order: $order,
            personId: $personId,
            enrollmentStatuses: $enrollmentStatuses,
            isPublished: $isPublished,
            localeCode: $localeCode,
            categoryId: $categoryId,
            _ids: $_ids,
            objectExcludeFormats: $objectExcludeFormats
        }) {
            totalCount
            searchOptions {
                page
                limit
            }
            edges {
                weight
                node {
                    ... on ES_Category {
                        categoryId
                        sortOrder
                        createdAt
                        updatedAt
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                        courseIds
                        curriculumIds
                        brand {
                            brandId
                            name
                        }
                        lxp {
                            relatedResourceBrandIds
                        }
                    }
                    ... on ES_Objective {
                        objectiveId
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                        lxp {
                            relatedResourceBrandIds
                        }
                        criteria {
                            criterionId
                            isEnabled
                            targetCount
                            targetValue
                            weight
                            criterionType {
                                criterionTypeId
                            }
                            name {
                                locale
                                content
                            }
                            description {
                                locale
                                content
                            }
                        }
                        createdAt
                        updatedAt
                        availableAt
                        isAvailable
                        isPublished
                        isRepeatable
                        points
                        credits
                        badgeRewardId: badgeId
                        publishAt
                        revisionId
                        unavailableAt
                    }
                    ... on ES_LearningObject {
                        learningObjectId
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                        createdAt
                        updatedAt
                        format
                        courseCount
                        usedByCourses {
                            name
                            uuid
                        }
                    }
                    ... on ES_Curriculum {
                        curriculumId
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                        thumbnailImage {
                            url
                        }
                        weight
                        createdAt
                        updatedAt
                        lxp {
                            relatedResourceBrandIds
                            relatedResourceLocaleIds
                            relatedResourceCompanyRelationshipIds,
                            relatedResourceProductIds
                            tags {
                                name
                            }
                            prerequisiteStatus { 
                                isPrerequisiteOf
                                hasPrerequisites
                            }
                            prerequisiteSet {
                                objectId
                                operator
                                type
                                prerequisites {
                                    objectId
                                    weight
                                }
                            }
                        }
                        courses {
                            courseId 
                            name {
                                locale
                                content
                            }
                        }
                    }
                        
                    ... on ES_Notification {
                        notificationId
                        isSticky
                        isFeatured
                        isPublished
                        weight
                        createdAt
                        updatedAt
                        publishAt
                        unpublishAt 
                        unfeatureAt 
                        lxp {
                            relatedResourceBrandIds
                        }
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                    }
                        
                    ... on ES_Course {
                        courseId
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                        isPublished
                        thumbnailImage {
                            url
                        }
                        isIlt
                        isFeatured
                        isSequential
                        createdAt
                        updatedAt
                        heroImage {
                            url
                        }
                        learningObjects {
                            learningObjectId 
                            name {
                                locale
                                content
                            }
                            format
                        }
                        lxp {
                            relatedResourceBrandIds
                            relatedResourceLocaleIds
                            relatedResourceCompanyRelationshipIds,
                            relatedResourceProductIds
                            tags {
                                name
                            }
                            prerequisiteStatus { 
                                isPrerequisiteOf
                                hasPrerequisites
                            }
                            prerequisiteSet {
                                objectId
                                operator
                                type
                                prerequisites {
                                    objectId
                                    weight
                                }
                            }
                        }
                    }
                    ... on ES_Leaderboard {
                        leaderboardId
                        leaderboardType
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                        granularity
                        leaderboardAudiences {
                            leaderboardAudienceId
                            name {
                                locale
                                content
                            }
                            description {
                                locale
                                content
                            }
                            createdAt
                            updatedAt

                        }
                        timezone
                        startAt
                        endAt
                        createdAt
                        updatedAt
                        isPublished
                        publishedAt
                        lxp {
                            relatedResourceBrandIds
                        }
                    }
                    ... on ES_Badge {
                        badgeId
                        badgeImage: image
                        name {
                            locale
                            content
                        }
                        description {
                            locale
                            content
                        }
                        personBadgeCount
                        createdAt
                        isRepeatable
                        updatedAt
                        isPublished
                        publishedAt
                        lxp {
                            relatedResourceBrandIds
                        }
                    }
                    ... on ES_Resource {
                        resourceId
                        name {
                            locale
                            content    
                        }
                        description {
                            locale
                            content    
                        }
                        resourceLocalizations {
                            resourceLocalizationId
                            name 
                            description 
                            localeCode
                            isDefault
                            resourceFile {
                                resourceFileId
                                genericFile {
                                    genericFileId
                                    name
                                    description
                                    filename
                                    mimetype
                                    url
                                    s3Url
                                }
                                lxpFile {
                                    lxpFileId
                                    name
                                    description
                                    filename
                                    status
                                    mimetype
                                }
                            }
                            resourceUrl {
                                resourceUrlId
                                url
                            }
                        }
                        type
                        image
                        lxp {
                            relatedResourceBrandIds
                            relatedResourceLocaleIds
                            relatedResourceSegmentIds
                            relatedResourceCompanyRelationshipIds,
                            relatedResourceProductIds
                            tags {
                                name
                                tagId
                            }
                            prerequisiteStatus { 
                                isPrerequisiteOf
                                hasPrerequisites
                            }
                            prerequisiteSet {
                                objectId
                                operator
                                type
                                prerequisites {
                                    objectId
                                    weight
                                }
                            }
                        }
                        isPublished
                        isActive
                        isFeatured
                        createdAt
                        updatedAt
                        publishedAt
                    }
                }
            }
        }
    }
`;

export default SEARCH_QUERY;
